import { render, staticRenderFns } from "./AboutTheCompany.vue?vue&type=template&id=775a939c&scoped=true"
import script from "./AboutTheCompany.vue?vue&type=script&lang=js"
export * from "./AboutTheCompany.vue?vue&type=script&lang=js"
import style0 from "./AboutTheCompany.vue?vue&type=style&index=0&id=775a939c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775a939c",
  null
  
)

export default component.exports